var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide-list fl-center"},[_vm._l((_vm.goodsList),function(item){return [_c('GoodsPanel',_vm._b({key:item.id,staticClass:"guide-item",on:{"handleTarget":_vm.handleTarget}},'GoodsPanel',item,false))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }